import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const DealershipServiceFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.26008 14.1401V20.3801H4.58008V4.08008H13.4001L9.60008 14.1401H6.26008Z" />
      <path d="M10.6001 16.2201L14.4001 6.16008H19.4201V11.1146C17.9798 10.8791 16.4497 11.3156 15.337 12.4283C14.2989 13.4664 13.8496 14.8682 13.9849 16.2201H10.6001Z" />
      <path d="M17.5326 15.3774L17.5339 15.3762L17.5291 15.3714L20.018 12.8825C19.5515 12.6609 19.042 12.5595 18.5362 12.5784C17.7642 12.6073 17.0007 12.9164 16.4114 13.5058C15.4926 14.4246 15.2549 15.7665 15.6982 16.9043L14.27 18.3796L13.3857 19.299L15.1782 21.0914L16.0672 20.173L17.4868 18.697C18.6269 19.1463 19.9746 18.91 20.8964 17.9882C21.8716 17.0129 22.0795 15.5609 21.52 14.3824L19.0288 16.8736L17.5326 15.3774Z" />
    </SvgIcon>
  );
});
